import {
  createCustomPage,
  deleteCustomPage,
  listCustomPages,
  retrieveCustomPage,
  updateCustomPage,
} from '@app/gen/custom-pages';
import {queryClient} from '@common/http/query-client';
import {mutationOptions, queryOptions} from '@tanstack/react-query';
import {FirstParam, SecondParam} from '@ui/utils/ts/extract-params';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';

export const customPagesBaseKey = ['custom-pages'];

export const listCustomPagesOptions = () => {
  return queryOptions({
    queryKey: customPagesBaseKey,
    queryFn: () => listCustomPages(),
  });
};

export const retrieveCustomPageOptions = (id: number | string) => {
  // Public slugs follow the visitor's country tab (multi-countries on); editors load by id.
  const boot = getBootstrapData().country;
  const country =
    /^\d+$/.test(String(id)) || !boot?.enabled ? undefined : boot.active?.code;
  return queryOptions({
    queryKey: [...customPagesBaseKey, `${id}`, country ?? 'editor'],
    queryFn: () => retrieveCustomPage(id, {params: country ? {country} : undefined}),
  });
};

export const createCustomPageOptions = () => {
  return mutationOptions({
    mutationFn: (body: FirstParam<typeof createCustomPage>) =>
      createCustomPage(body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: customPagesBaseKey});
    },
  });
};

export const updateCustomPageOptions = (id: number) => {
  return mutationOptions({
    mutationFn: (body: SecondParam<typeof updateCustomPage>) =>
      updateCustomPage(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: customPagesBaseKey});
    },
  });
};

export const deleteCustomPageOptions = () => {
  return mutationOptions({
    mutationFn: (id: number) => deleteCustomPage(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: customPagesBaseKey});
    },
  });
};
